import {
  ADD_RATE,
  ADD_RATE_FAILURE,
  ADD_RATE_SUCCESS,
  //
  DELETE_RATE,
  DELETE_RATE_FAILURE,
  DELETE_RATE_SUCCESS,
  //
  EDIT_RATE,
  EDIT_RATE_FAILURE,
  EDIT_RATE_SUCCESS,
  //
  FETCH_RATES,
  FETCH_RATES_FAILURE,
  FETCH_RATES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_RATE_ADD_MODAL,
} from "./constants";

// List
export const fetchRates = (payload, onSuccess) => ({
  type: FETCH_RATES,
  payload,
  onSuccess,
});
export const fetchRatesSuccess = (payload) => ({
  type: FETCH_RATES_SUCCESS,
  payload,
});
export const fetchRatesFailure = (payload) => ({
  type: FETCH_RATES_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addRate = (payload, onSuccess) => ({
  type: ADD_RATE,
  payload,
  onSuccess,
});
export const addRateSuccess = (payload) => ({
  type: ADD_RATE_SUCCESS,
  payload,
});
export const addRateFailure = (payload) => ({
  type: ADD_RATE_FAILURE,
  payload,
});
// EDIT
export const editRate = (payload, onSuccess) => ({
  type: EDIT_RATE,
  payload,
  onSuccess,
});
export const editRateSuccess = (payload) => ({
  type: EDIT_RATE_SUCCESS,
  payload,
});
export const editRateFailure = (payload) => ({
  type: EDIT_RATE_FAILURE,
  payload,
});
// DELETE
export const deleteRate = (payload, onDelete) => ({
  type: DELETE_RATE,
  payload,
  onDelete,
});
export const deleteRateSuccess = (payload) => ({
  type: DELETE_RATE_SUCCESS,
  payload,
});
export const deleteRateFailure = (payload) => ({
  type: DELETE_RATE_FAILURE,
  payload,
});

export const toggleRateAddModal = (payload) => ({
  type: TOGGLE_RATE_ADD_MODAL,
  payload,
});
